import HeroSection from "../components/heroSection/HeroSection";
import ProjectsComponent from "../components/Projects";
import ClientTestimonials from "../components/ClientTestimonials";
import { Helmet } from "react-helmet";

function Projects() {
  return (
    <div data-aos="zoom-in">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Projects | Al Ghaith Properties</title>
        <meta name="description" content="Browse our portfolio of premium villas, apartments, and commercial properties in Dubai. Discover your next home or business space with Al Ghaith Properties." />
        <link rel="canonical" href="https://www.al-ghaith.ae/projects" />
      </Helmet>
      <HeroSection page={"Projects"} />
      <ProjectsComponent />
      <ClientTestimonials />
    </div>
  );
}

export default Projects;